module.exports = __webpack_public_path__ + "img/list.2d8e5a97.png";